export * from "./database.types";
export * from "./quote";

export const APP_NAME = "LawnOps";
export const APP_VERSION = "0.0.0";

export const PRICING_TIERS = {
  starter: {
    id: "starter",
    name: "Starter",
    monthlyPriceUsd: 59,
    customerCap: 150,
    satelliteQuotesPerMonth: 15,
  },
  pro: {
    id: "pro",
    name: "Pro",
    monthlyPriceUsd: 119,
    customerCap: 500,
    satelliteQuotesPerMonth: Infinity,
  },
  scale: {
    id: "scale",
    name: "Scale",
    monthlyPriceUsd: 239,
    customerCap: Infinity,
    satelliteQuotesPerMonth: Infinity,
  },
} as const;

export type PricingTierId = keyof typeof PRICING_TIERS;

// Slug helper used by org-creation flow.
export function slugify(input: string): string {
  return input
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}
